import type { MieterPanelKey } from '../../../../../components/immobilien/mieterWidgets';
import { KautionPanel, KontoPanel, MietePanel } from './FinanzPanels';
import { MietverhaeltnisPanel, PortalPanel, StammdatenPanel } from './MieterPanels';
import { BriefePanel } from './BriefePanel';
import { AktivitaetPanel, DokumentePanel, KiPanel, NotizenPanel, TerminePanel, TicketsPanel, VertraegePanel, ZaehlerPanel } from './VerwaltungPanels';

/** Inhalt des geöffneten Panels (Handoff Mieter §6). */
export function MieterPanelInhalt({ panel }: { panel: MieterPanelKey }) {
  switch (panel) {
    case 'konto': return <KontoPanel />;
    case 'miete': return <MietePanel />;
    case 'kaution': return <KautionPanel />;
    case 'kontakt': return <StammdatenPanel />;
    case 'mv': return <MietverhaeltnisPanel />;
    case 'portal': return <PortalPanel />;
    case 'aktivitaet': return <AktivitaetPanel />;
    case 'vertraege': return <VertraegePanel />;
    case 'dokumente': return <DokumentePanel />;
    case 'briefe': return <BriefePanel />;
    case 'termine': return <TerminePanel />;
    case 'tickets': return <TicketsPanel />;
    case 'zaehler': return <ZaehlerPanel />;
    case 'notizen': return <NotizenPanel />;
    case 'ki': return <KiPanel />;
  }
}
